import React, { useState, useEffect } from 'react';
import { getLocale, useIntl } from 'umi';
import { Modal } from 'tea-component';
import cls from 'classnames';
import VersionDetails from './VersionDetails';
import { moduleOptions, getSysEvnType } from './_config';
import VersionImg from './VersionImg';
import { PageLogMes } from '@/pages/home/utils/buriedPointCfg';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import { versionVisit } from '@/pages/home/services/versionPopup';
import '@/pages/home/assets/scss/page/home/components/versionPopup.scss';

export default function VersionHistory(props: any) {
  const {
    // props字段看是点击进来还是自动展示进来
    autoPopup,
    visible: visibleProp,
    close = () => console.log,
    versionName,
    versionInfo,
  } = props;
  const { formatMessage } = useIntl();
  const isCN = getLocale() === LANGUAGE_CN;
  // 使用环境：用于发送查询参数
  const sysEnv = getSysEvnType();
  const [versionVisible, setVersionVisible] = useState(visibleProp);
  const [detailsVisible, setDetailsVisible] = useState(false); // 打开详情
  const [showAutoContext, setShowAutoContext] = useState(autoPopup); // 是否展示自动弹窗内容
  const [activeModule, setActiveModule] = useState(0);

  // 判断是否为 Mac 字体，字体间距问题处理
  const isMac = navigator.userAgent.indexOf('Mac') !== -1;

  const versionHistoryTip = formatMessage(
    { id: 'dbh_versionhistory_history_tip' },
    {
      email: (
        <span className="version-history-tip-email">
          DataBrain_noreply@databrain.levelinfinite.com
        </span>
      ),
      br: <br />,
    },
  );

  useEffect(() => {
    setVersionVisible(visibleProp);
    setShowAutoContext(autoPopup);
  }, [visibleProp, autoPopup]);

  const getChange = (index: any) => {
    setActiveModule(index);
    setVersionVisible(false);
    setDetailsVisible(true);
  };

  const detailsReback = () => {
    setDetailsVisible(false);
    setVersionVisible(true);
    // 从详情页返回则不展示自动弹窗的内容
    setShowAutoContext(false);
  };

  const closeModal = async () => {
    if (showAutoContext) {
      // 自动弹窗关闭发已读
      await versionVisit({
        sys_env: sysEnv,
        sys_type: versionInfo.sys_type,
        version_name: versionInfo.version_name_api,
      });
    }
    setVersionVisible(false);
    setDetailsVisible(false);
    close();
  };

  useEffect(() => {
    // 添加打点
    buriedPointPage(PageLogMes.versionPreview);
  }, [versionVisible]);

  return (
    <>
      <Modal
        visible={versionVisible}
        className="version-history"
        // caption={formatMessage({ id: 'dbh_versionhistory_history' })}
        caption={
          <div>
            {formatMessage({ id: 'dbh_versionhistory_history' })}
            <div
              className={cls({
                'version-history-tip': true,
                'no-letter-spacing': isMac,
              })}
            >
              {versionHistoryTip}
            </div>
          </div>
        }
        size={1000}
        onClose={closeModal}
      >
        <Modal.Body>
          <div className="version-history-list">
            {/** 自动弹窗内容 */}
            {showAutoContext && (
              <div className="version-history-option">
                <VersionImg
                  // showPicName={false}
                  versionName={versionName}
                  versionContent={versionInfo?.version_content}
                />
              </div>
            )}

            {/** 板块内容 */}
            <div className="version-popup-view">
              {moduleOptions.map((e: any) => (
                <div
                  className="version-popup-img"
                  key={e.sysType}
                  onClick={() => {
                    getChange(e.sysType);
                  }}
                >
                  <img src={isCN ? e.imgSrcCn : e.imgSrcEn} />
                </div>
              ))}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <VersionDetails
        visible={detailsVisible}
        closeDetails={closeModal}
        detailsReback={detailsReback}
        activeModule={activeModule}
      />
    </>
  );
}
